enum ControlAppPaths {
  Home = '/',
  NotFound = '/*',
  WrongNetwork = '/wrong-network',
  LoggedOut = '/logged-out',
  KioskLogout = '/kiosk-logout',
}

export default ControlAppPaths;
